/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";
export const GET_DETAILED_NODE = gql`
query GetManyStudPortfolios($input: GetManyStudentPortfoliostInput) {
  getManyStudPortfolios(input: $input) {
    currentPage
    data {
      email
      display
      description
      createdAt
      credentials
      bannerImage
      feedback
      goal
      id
      logo
      name
      recommendation
      socialLinks
      state
      updatedAt
      userGroup
      uuid
    }
    pageSize
    totalCount
    totalPages
  }
}

`;
